
import React, { useEffect, useRef, useState } from "react";
import { X, Mail, Loader2 } from "lucide-react";
import TextInputComp from "./TextInputComp";
import CommonButton from "../CommonButton";

import {
  useCustomerEmailLoginMutation,
  useCustomerEmailOtpMutation,
  useGuestLoginMutation,
  // useCustomerLoginMutation, // TEMPORARILY DISABLED
  // useCustomerOtpMutation, // TEMPORARILY DISABLED
} from "../../redux/actions/Customer/authCustomer";

import { useAlert } from "./AlertContext";

import {
  CustomerEmailLoginRequest,
  CustomerEmailOtpRequest,
  // CustomerLoginRequest, // TEMPORARILY DISABLED
  // CustomerOtpRequest, // TEMPORARILY DISABLED
} from "../../types/Request/CustomerRequest";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  setCustomerLoggedIn,
  setLogin,
} from "../../redux/reducers/authReducer";

import { setRegisteredLogin } from "../../redux/reducers/Customer/customerReducer";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onLoginSuccess?: () => void;
  message?: string;
  guestVerification?: boolean;
  guestPhoneNumber?: string;
  guestEmail?: string;
  referralCode?: string;
  ShowGuestClick?: boolean;

}

const LoginModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onLoginSuccess,
  message,
  guestVerification = false,
  guestPhoneNumber = "",
  guestEmail = "",
  referralCode = "",
  ShowGuestClick = true,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showConfirm } = useAlert();
  const [guestLogin] = useGuestLoginMutation();


  // ============================================================
  // State Management
  // ============================================================

  const [inputValue, setInputValue] = useState<string>("");
  const [detectedType, setDetectedType] = useState<"email" | "empty">(
    "empty"
  );

  // Mobile OTP temporarily disabled
  // const guestOtpStartedRef = useRef(false);

  const [step, setStep] = useState<"email" | "otp">("email");

  const [otp, setOtp] = useState<string[]>(["", "", "", ""]);
  const inputsRef = useRef<(HTMLInputElement | null)[]>([]);

  const [error, setError] = useState<string | null>(null);
  const [otpError, setOtpError] = useState<string | null>(null);

  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  // ============================================================
  // RTK Mutations
  // ============================================================

  const [customerEmailLogIn] = useCustomerEmailLoginMutation();

  // Mobile OTP temporarily disabled
  // const [customerPhoneLogIn] = useCustomerLoginMutation();

  const [verifyEmailOtp] = useCustomerEmailOtpMutation();

  // Mobile OTP temporarily disabled
  // const [verifyPhoneOtp] = useCustomerOtpMutation();

  const finalOtp = otp.join("");

  // ============================================================
  // Email Only
  // ============================================================

  useEffect(() => {
    // Mobile guest OTP temporarily disabled.fv
    //
    // if (!isOpen || !guestVerification || !guestPhoneNumber) {
    //   return;
    // }
    //
    // if (guestOtpStartedRef.current) {
    //   return;
    // }
    //
    // const startGuestOtp = async () => {
    //   try {
    //     setIsLoading(true);
    //
    //     const digitsOnly = guestPhoneNumber.replace(/\D/g, "");
    //
    //     const localPhone = digitsOnly.startsWith("971")
    //       ? digitsOnly.substring(3)
    //       : digitsOnly;
    //
    //     setInputValue(localPhone);
    //     setDetectedType("phone");
    //     setStep("otp");
    //     setOtp(["", "", "", ""]);
    //     setOtpError(null);
    //
    //     await customerPhoneLogIn({
    //       phoneNumber: guestPhoneNumber,
    //     }).unwrap();
    //
    //     guestOtpStartedRef.current = true;
    //
    //     console.log(
    //       "Guest phone OTP sent:",
    //       guestPhoneNumber
    //     );
    //   } catch (error: any) {
    //     console.error("Guest OTP send failed:", error);
    //
    //     guestOtpStartedRef.current = false;
    //
    //     showConfirm({
    //       title: "OTP Error",
    //       message:
    //         error?.data?.message ||
    //         error?.data?.Message ||
    //         "Unable to send OTP. Please try again.",
    //       type: "error",
    //       confirmText: "OK",
    //     });
    //   } finally {
    //     setIsLoading(false);
    //   }
    // };
    //
    // startGuestOtp();

    return;
  }, [
    isOpen,
    guestVerification,
    guestPhoneNumber,
    // customerPhoneLogIn,
  ]);

  // ============================================================
  // Guest Verification - EMAIL OTP ONLY
  // ============================================================

  const guestOtpStartedRef = useRef(false);

  useEffect(() => {
    if (!isOpen || !guestVerification || !guestEmail) {
      return;
    }

    // Prevent duplicate API calls
    if (guestOtpStartedRef.current) {
      return;
    }

    const startGuestOtp = async () => {
      const email = guestEmail.trim().toLowerCase();

      if (!email) {
        return;
      }

      try {
        guestOtpStartedRef.current = true;
        setIsLoading(true);

        // Directly go to OTP screen
        setInputValue(email);
        setDetectedType("email");
        setStep("otp");
        setOtp(["", "", "", ""]);
        setOtpError(null);

        // Automatically send EMAIL OTP
        await customerEmailLogIn({
          email,
          referralCode: referralCode || undefined,
        }).unwrap();

        console.log(
          "Guest EMAIL OTP sent automatically:",
          email
        );
      } catch (error: any) {
        console.error(
          "Guest EMAIL OTP send failed:",
          error
        );

        guestOtpStartedRef.current = false;

        showConfirm({
          title: "OTP Error",
          message:
            error?.data?.message ||
            error?.data?.Message ||
            "Unable to send OTP. Please try again.",
          type: "error",
          confirmText: "OK",
        });
      } finally {
        setIsLoading(false);
      }
    };

    startGuestOtp();
  }, [
    isOpen,
    guestVerification,
    guestEmail,
    customerEmailLogIn,
    referralCode,
    showConfirm,
  ]);

  const handleGuestClick = async () => {
    try {
      const res = await guestLogin({}).unwrap();

      console.log("GUEST API HIT", res);

      if (res.success) {
        dispatch(
          setLogin({
            role: "customer",
            customerType: "guest",
            userId: "guest_user",
            userName: "Guest",
          }),
        );

        localStorage.setItem("locationPopupShown", "true");

        onClose();
      }
    } catch (error) {
      console.error("Guest login failed:", error);
    }
  };
  // ============================================================
  // OTP Timer
  // ============================================================

  useEffect(() => {
    if (step === "otp") {
      startTimer();
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [step]);

  if (!isOpen) return null;

  const startTimer = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    setTimer(30);
    setCanResend(false);

    intervalRef.current = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
          }

          setCanResend(true);

          return 0;
        }

        return prev - 1;
      });
    }, 1000);
  };

  // ============================================================
  // Input Change - EMAIL ONLY
  // ============================================================

  const handleInputChange = (text: string) => {
    if (error) {
      setError(null);
    }

    setInputValue(text);

    if (!text) {
      setDetectedType("empty");
      return;
    }

    // Mobile detection temporarily disabled.
    // Everything is treated as email now.
    setDetectedType("email");
  };

  // ============================================================
  // Validation
  // ============================================================

  const validateInputs = (): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(inputValue)) {
      setError("Enter a valid email address");
      return false;
    }

    setError(null);

    return true;
  };

  // ============================================================
  // Close
  // ============================================================

  const handleClose = () => {
    // Mobile OTP temporarily disabled
    // guestOtpStartedRef.current = false;
    guestOtpStartedRef.current = false;
    setInputValue("");
    setDetectedType("empty");

    setStep("email");

    setOtp(["", "", "", ""]);

    setError(null);
    setOtpError(null);

    setTimer(30);
    setCanResend(false);

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    onClose();
  };

  // ============================================================
  // Continue - EMAIL ONLY
  // ============================================================

  const handleContinue = async () => {
    if (!validateInputs()) {
      return;
    }

    setIsLoading(true);

    try {
      const data: CustomerEmailLoginRequest = {
        email: inputValue.trim().toLowerCase(),
        referralCode: referralCode || undefined,
      };

      const response = await customerEmailLogIn(data);

      if (response.data?.success === true) {
        setStep("otp");
      } else {
        showConfirm({
          title: "Error",
          message:
            response.data?.message ||
            "Something went wrong",
          type: "error",
          confirmText: "OK",
        });
      }
    } catch (e) {
      showConfirm({
        title: "Network Error",
        message: "Something went wrong",
        type: "error",
        confirmText: "OK",
      });
    } finally {
      setIsLoading(false);
    }
  };

  // ============================================================
  // Verify OTP - EMAIL ONLY
  // ============================================================

  const handleVerifyOtp = async () => {
    if (finalOtp.length !== 4) {
      setOtpError("Enter valid OTP");
      return;
    }

    setOtpError(null);
    setIsLoading(true);

    try {
      const commonPayload = {
        otpCode: finalOtp,
        deviceId: "1234",
        deviceName: "abc",
        clientType: 1,
        referralCode: referralCode || undefined,
      };

      const payload: CustomerEmailOtpRequest = {
        email: inputValue.trim().toLowerCase(),
        ...commonPayload,
      };

      console.log("REQUEST FOR PROFILE", payload);

      const response = await verifyEmailOtp(payload);

      if (response.data?.success === true) {
        console.log("=========== OTP RESPONSE ===========");
        console.log(response);
        console.log("====================================");

        const name =
          response.data?.data?.fullName ||
          "PetLand User";

        console.log("Resolved User Name:", name);

        dispatch(setRegisteredLogin(true));

        dispatch(
          setCustomerLoggedIn({
            userId: String(
              response.data?.data?.walletBalance
            ),
            userName: name,
            customerType: "registered",
          })
        );

        localStorage.setItem("userName", name);

        localStorage.setItem(
          "locationPopupShown",
          "true"
        );

        localStorage.removeItem("referralCode");

        // Notify caller that login completed.
        onLoginSuccess?.();

        handleClose();
      } else {
        showConfirm({
          title: "Error",
          message:
            response.data?.message ||
            "Invalid OTP",
          type: "error",
          confirmText: "OK",
        });
      }
    } catch (error: any) {
      console.error("error", error);

      showConfirm({
        title: "Network Error",
        message:
          error?.Message ||
          "Something went wrong",
        type: "error",
        confirmText: "OK",
      });
    } finally {
      setIsLoading(false);
    }
  };

  // ============================================================
  // Resend OTP - EMAIL ONLY
  // ============================================================

  const handleResendOtp = async () => {
    setOtp(["", "", "", ""]);
    setOtpError(null);
    setIsLoading(true);

    try {
      await customerEmailLogIn({
        email: inputValue
          .trim()
          .toLowerCase(),

        referralCode:
          referralCode || undefined,
      });

      startTimer();
    } catch (err) {
      console.error("Resend error", err);
    } finally {
      setIsLoading(false);
    }
  };

  // ============================================================
  // OTP Input
  // ============================================================

  const handleOtpChange = (
    value: string,
    index: number
  ) => {
    if (!/^[0-9]?$/.test(value)) {
      return;
    }

    if (otpError) {
      setOtpError(null);
    }

    const newOtp = [...otp];

    newOtp[index] = value;

    setOtp(newOtp);

    if (
      value &&
      index < otp.length - 1
    ) {
      inputsRef.current[
        index + 1
      ]?.focus();
    }
  };

  const handleBackspace = (
    e: any,
    index: number
  ) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const newOtp = [...otp];

        newOtp[index] = "";

        setOtp(newOtp);
      } else if (index > 0) {
        inputsRef.current[
          index - 1
        ]?.focus();
      }
    }
  };

  // ============================================================
  // UI
  // ============================================================

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/60 backdrop-blur-sm animate-fade-in">
      <div className="relative w-full sm:w-[90%] max-w-md bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl overflow-hidden max-h-[90vh] overflow-y-auto transform transition-all duration-300">

        {/* Loading Overlay */}
        {isLoading && (
          <div className="absolute inset-0 bg-white/70 backdrop-blur-[2px] z-50 flex flex-col items-center justify-center gap-2 animate-fade-in">
            <Loader2 className="h-9 w-9 animate-spin text-blue-600" />

            <span className="text-sm font-semibold text-gray-700">
              Processing...
            </span>
          </div>
        )}

        {/* Close Button */}
        <button
          disabled={isLoading}
          onClick={handleClose}
          className="absolute top-4 right-4 bg-black/30 backdrop-blur-md text-white rounded-full p-1.5 hover:bg-black/50 transition z-10 cursor-pointer disabled:opacity-50"
        >
          <X size={18} />
        </button>

        {/* Cover Image Header */}
        <div className="w-full h-28 sm:h-36 md:h-44 relative">
          <img
            src="https://plus.unsplash.com/premium_photo-1661676172038-377ab3d82a18?w=600&auto=format&fit=crop&q=60"
            className="w-full h-full object-cover"
            alt="Pets Header"
          />

          <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent" />
        </div>

        <div className="px-5 sm:px-6 pb-6 pt-2">

          {/* ====================================================
              STEP 1: EMAIL LOGIN
          ==================================================== */}

          {step === "email" && (
            <>
              <div className="text-center mb-5">
                <h2 className="text-xl sm:text-2xl font-bold text-gray-800 tracking-tight">
                  Welcome Back!
                </h2>

                <p className="text-xs sm:text-sm text-gray-500 mt-1">
                  Enter your email to continue.
                </p>
              </div>

              {message && (
                <div className="mb-4 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2">
                  <p className="text-xs font-medium text-amber-800">
                    {message}
                  </p>
                </div>
              )}

              {referralCode && (
                <div className="mb-4 rounded-lg bg-green-50 border border-green-200 px-3 py-2 text-center">
                  <p className="text-xs text-green-700">
                    Referral code applied:{" "}
                    <span className="font-semibold">
                      {referralCode}
                    </span>
                  </p>
                </div>
              )}

              <div className="space-y-4">

                <div className="relative flex items-center">

                  {/* Email Icon */}
                  <span className="absolute left-3.5 text-gray-400 z-10 pointer-events-none">
                    <Mail size={18} />
                  </span>

                  <div className="w-full">
                    <TextInputComp
                      type="text"
                      placeholder="Email"
                      value={inputValue}
                      disabled={isLoading}
                      onChangeText={handleInputChange}
                      className="w-full pl-11 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:border-blue-500 focus:bg-white transition-all text-sm outline-none"
                      error={error}
                    />
                  </div>
                </div>

                {error && (
                  <p className="text-xs text-red-500 font-medium px-1">
                    {error}
                  </p>
                )}

              <div className="pt-1 flex flex-col gap-2">
  <CommonButton
    text={"Continue"}
    disabled={isLoading}
    onClick={handleContinue}
    className="w-full font-semibold shadow-md shadow-blue-500/10 hover:shadow-lg active:scale-[0.98] transition-all"
    variant="filled"
    rounded="md"
  />

  {ShowGuestClick && (
    <CommonButton
      text="Continue as Guest"
      className="w-full font-semibold shadow-md shadow-blue-500/10 hover:shadow-lg active:scale-[0.98] transition-all"
      rounded="lg"
      variant="outline"
      onClick={handleGuestClick}
    />
  )}
</div>

              </div>
            </>
          )}

          {/* ====================================================
              STEP 2: OTP VERIFICATION
          ==================================================== */}

          {step === "otp" && (
            <>
              <h2 className="text-base md:text-lg font-semibold text-center pb-2 text-logoHeading">
                Enter OTP
              </h2>

              <div className="flex flex-col items-center gap-1 justify-center pb-3">

                <p className="text-xs text-center text-gray-500">
                  An OTP has been sent to{" "}
                  <span className="font-semibold text-gray-700">
                    {inputValue}
                  </span>
                </p>

                <button
                  onClick={() => {
                    setStep("email");
                    setOtp(["", "", "", ""]);
                  }}
                  className="text-xs underline text-blue-600"
                >
                  Change details
                </button>

              </div>

              {/* OTP Fields */}
              <div
                className={`flex justify-center gap-2 ${!otpError
                    ? "mb-2"
                    : "mb-0"
                  }`}
              >
                {otp.map((digit, i) => (
                  <TextInputComp
                    key={i}
                    type="tel"
                    value={digit}
                    onChangeText={(val) =>
                      handleOtpChange(
                        val,
                        i
                      )
                    }
                    maxLength={1}
                    className="w-10 h-10 md:w-12 md:h-12 text-center text-lg p-0"
                    ref={(el) => {
                      inputsRef.current[i] =
                        el;
                    }}
                    onKeyDown={(e: any) =>
                      handleBackspace(
                        e,
                        i
                      )
                    }
                  />
                ))}
              </div>

              {otpError && (
                <p className="text-sm text-red-500 text-center mb-2">
                  {otpError}
                </p>
              )}

              <div className="text-center mb-3">
                {!canResend ? (
                  <p className="text-sm text-gray-500">
                    Resend OTP in {timer}s
                  </p>
                ) : (
                  <button
                    onClick={handleResendOtp}
                    className="text-sm text-red-600 underline border-none bg-transparent cursor-pointer"
                  >
                    Resend OTP
                  </button>
                )}
              </div>

              <CommonButton
                text="Verify & Continue"
                disabled={
                  finalOtp.length !== 4
                }
                onClick={handleVerifyOtp}
                variant="filled"
                rounded="md"
                className="w-full"
              />
            </>
          )}

          {/* Footer Branding Links */}
          <p className="text-[11px] text-gray-400 mt-5 text-center leading-relaxed">
            By continuing, you agree to our{" "}

            <span
              onClick={() => {
                handleClose();
                navigate(
                  "/privacyPolicy"
                );
              }}
              className="text-blue-500 hover:underline font-medium cursor-pointer"
            >
              Privacy Policy
            </span>{" "}

            &{" "}

            <span
              onClick={() => {
                handleClose();
                navigate(
                  "/termsAndConditions"
                );
              }}
              className="text-blue-500 hover:underline font-medium cursor-pointer"
            >
              Terms of Service.
            </span>
          </p>

        </div>
      </div>
    </div>
  );
};

export default LoginModal;

